var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"total-time"},[(_vm.hasData)?[_vm._v("\n    "+_vm._s(_vm.calculatedTime.duration)+" "),_c('span',[_vm._v(_vm._s(_vm.calculatedTime.units))])]:[_vm._v(" -- ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }